/**
 * app-layout.tsx — Khung màn chính: thanh menu NGANG trên cùng + nội dung.
 *
 * Trước đây có hai kiểu menu (dọc / ngang) và một nút chuyển qua lại, lưu lựa
 * chọn ở máy từng người. Nay chỉ còn một kiểu: hai bố cục nghĩa là mọi màn hình
 * phải chạy đúng ở cả hai, và mỗi màn mới lại phải thử hai lần — không đáng, khi
 * cả nhà đều dùng menu ngang. Bỏ luôn nút chuyển để không ai lỡ tay rơi vào bố
 * cục không còn được kiểm thử.
 */
import { Outlet, useLocation } from 'react-router-dom'
import { TopNav } from '@/components/shared/top-nav'
import { ImpersonationBanner } from '@/pages/conversations/view-as-staff'

/**
 * Màn nào chiếm TRỌN phần dưới thanh menu, không đóng khung 1400px có lề.
 *
 * Màn Hội thoại là nơi nhân viên ngồi cả ngày với ba cột (lọc · danh sách ·
 * khung chat · hồ sơ khách): bó vào khung có lề là lãng phí hai bên màn hình
 * rộng, và khung chat phải tự cuộn bên trong thay vì cuộn theo trang.
 */
const TOAN_MAN_HINH = ['/conversations']

export function AppLayout() {
  const { pathname } = useLocation()
  const toanManHinh = TOAN_MAN_HINH.some((p) => pathname === p || pathname.startsWith(`${p}/`))

  return (
    <div className="flex h-screen flex-col overflow-hidden bg-background">
      <ImpersonationBanner />
      <TopNav />
      {/*
        min-w-0: cột flex mặc định không co dưới min-content — nội dung dài
        (bảng, markdown…) sẽ đẩy tràn ngang làm cả trang trượt. overflow-x-hidden
        chặn cuộn ngang toàn trang; phần rộng phải tự cuộn trong khung riêng.
      */}
      {toanManHinh ? (
        <main className="min-h-0 min-w-0 flex-1 overflow-hidden">
          <Outlet />
        </main>
      ) : (
        <main className="min-w-0 flex-1 overflow-y-auto overflow-x-hidden">
          <div className="mx-auto max-w-[1400px] p-6">
            <Outlet />
          </div>
        </main>
      )}
    </div>
  )
}
